import React, { memo } from 'react'
import { useDispatch } from 'react-redux'
import { Typography, Grid } from '@material-ui/core/'
import { setStep3 } from '../../../../../modules/story/actions'
import closeIcon from '../../../../../assetss/img/closeModalIcon.svg'
import { LazyLoadImage, trackWindowScroll } from 'react-lazy-load-image-component'
import c from 'classnames'
import 'react-lazy-load-image-component/src/effects/blur.css'
import './index.scss'

const ImgsContainer = memo(({ imgs, setLoading, setImgId, setSrcImg, onClose, open }) => {
  const dispatch = useDispatch()

  return (
    <Grid className={c('imgsNewStoryContainer', open && 'imgsNewStoryContainerOpen')} onClick={() => onClose(false)}>
      <Grid className='wrapperImgsBox'>
        <Grid className='headerImgBlock'>
          <Grid className='boxClose'><img onClick={() => onClose(false)} className='closeIcon' src={closeIcon} /></Grid>
          <Typography className='titleImgsBox'>Image library</Typography>
        </Grid>
        <Grid className='imgsItemsBlock'>
          <Grid className='wrapperItemsBlock'>
            {
              imgs?.map((i, item) => (
                <LazyLoadImage
                  key={item}
                  alt='img'
                  height={108}
                  src={i.src}
                  width={170}
                  effect='blur'
                  className='imgContainer'
                  onClick={() => {
                    setImgId(i?.uuid)
                    setSrcImg(i?.src)
                    onClose(false)
                    dispatch(setStep3({ imageUuid: i?.uuid, src: i?.src }))
                  }}
                />
              ))
            }
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
})

export default trackWindowScroll(ImgsContainer)
